module.exports = __webpack_public_path__ + "db13742dbdd53dc96d7c1b23911c3a1b.pdf";